import { render } from "./HeaderNazgul.vue?vue&type=template&id=a641fada&scoped=true"
import script from "./HeaderNazgul.vue?vue&type=script&lang=js"
export * from "./HeaderNazgul.vue?vue&type=script&lang=js"

import "./HeaderNazgul.vue?vue&type=style&index=0&id=a641fada&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a641fada"]])

export default __exports__